/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   * @param {string} handle - The handle of the product to add.
   */
  static addProduct(productId, handle) {
    let objects = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    objects = objects.filter((e) => (typeof e === 'object' ? e.id : e) !== productId);
    objects.unshift({ id: productId, handle });
    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(objects.slice(0, this.#MAX_PRODUCTS)));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed product IDs from localStorage.
   * @returns {string[]} The list of product IDs.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]')
      .map((e) => (typeof e === 'object' ? e.id : e));
  }

  /**
   * Retrieves the list of recently viewed product handles from localStorage.
   * @returns {string[]} The list of product handles.
   */
  static getHandles() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]')
      .filter((e) => typeof e === 'object' && e.handle)
      .map((e) => e.handle);
  }
}
